/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';


export default declareLinkedEntity({
    entity: "channelScriptDefs",
    graphQL: "ChannelScriptDef",
    name: "Application Scripts",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "channelScriptDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Application Script Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Name",
            type: "string",
            defaultValue: "",
        },
        script: {
            name: "Script",
            type: "javascript",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
            defaultValue: "",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
